var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateRandomDailyData } from '@web/lib/demo/utils';
import { getPercentageDiff } from '@workalizer/shared/utils';
var withVolumeDiffs = function (messages, reactions) { return ({
    prevMessages: getPercentageDiff(Math.round(messages * 0.9), messages),
    prevReactions: getPercentageDiff(Math.round(reactions * 0.9), reactions)
}); };
export var chatRoomsByMessageVolume = function (input) {
    var dateFrom = input.dateFrom, dateTo = input.dateTo;
    var datesForTrend = generateRandomDailyData(dateFrom, dateTo);
    var getDate = function (index) {
        var _a, _b;
        return (((_a = datesForTrend[index]) === null || _a === void 0 ? void 0 : _a.date) ||
            ((_b = datesForTrend[datesForTrend.length - 1]) === null || _b === void 0 ? void 0 : _b.date) ||
            dateFrom);
    };
    return [
        __assign(__assign({ roomId: 67, roomName: 'All Hands Follow-up', volumeTrend: [
                { date: getDate(0), value: 8 },
                { date: getDate(1), value: 12 },
                { date: getDate(2), value: 5 },
                { date: getDate(3), value: 15 },
                { date: getDate(4), value: 10 },
                { date: getDate(5), value: 7 },
                { date: getDate(6), value: 13 }
            ], messages: 373, reactions: 88 }, withVolumeDiffs(373, 88)), { activeParticipants: 92, externalPercent: 27, topPosters: [
                {
                    userId: 1,
                    name: 'Alex Morgan',
                    posts: 64,
                    department: 'Engineering'
                },
                { userId: 2, name: 'Priya Shah', posts: 58, department: 'Product' },
                { userId: 3, name: 'Jordan Lee', posts: 51, department: 'Design' },
                { userId: 4, name: 'Sam Rivera', posts: 47, department: 'Sales' },
                { userId: 5, name: 'Casey Kim', posts: 42, department: 'Support' }
            ] }),
        __assign(__assign({ roomId: 86, roomName: 'Design Review', volumeTrend: [
                { date: getDate(0), value: 3 },
                { date: getDate(1), value: 6 },
                { date: getDate(2), value: 2 },
                { date: getDate(3), value: 8 },
                { date: getDate(4), value: 4 },
                { date: getDate(5), value: 9 },
                { date: getDate(6), value: 1 }
            ], messages: 214, reactions: 61 }, withVolumeDiffs(214, 61)), { activeParticipants: 38, externalPercent: 18, topPosters: [
                { userId: 6, name: 'Jordan Lee', posts: 41, department: 'Design' },
                {
                    userId: 7,
                    name: 'Alex Morgan',
                    posts: 36,
                    department: 'Engineering'
                },
                { userId: 8, name: 'Riley Chen', posts: 29, department: 'Product' },
                { userId: 9, name: 'Morgan Blake', posts: 24, department: 'Marketing' },
                { userId: 10, name: 'Taylor Brooks', posts: 19, department: 'Support' }
            ] }),
        __assign(__assign({ roomId: 130, roomName: 'Product Weekly', volumeTrend: [
                { date: getDate(0), value: 2 },
                { date: getDate(1), value: 4 },
                { date: getDate(2), value: 1 },
                { date: getDate(3), value: 5 },
                { date: getDate(4), value: 3 },
                { date: getDate(5), value: 6 },
                { date: getDate(6), value: 2 }
            ], messages: 301, reactions: 134 }, withVolumeDiffs(301, 134)), { activeParticipants: 54, externalPercent: 43, topPosters: [
                { userId: 11, name: 'Taylor Kim', posts: 66, department: 'Marketing' },
                { userId: 12, name: 'Priya Shah', posts: 52, department: 'Product' },
                { userId: 13, name: 'Sam Rivera', posts: 44, department: 'Sales' },
                { userId: 14, name: 'Casey Kim', posts: 38, department: 'Support' },
                {
                    userId: 15,
                    name: 'Alex Morgan',
                    posts: 31,
                    department: 'Engineering'
                }
            ] }),
        __assign(__assign({ roomId: 45, roomName: 'CSM-internal', volumeTrend: [
                { date: getDate(0), value: 1 },
                { date: getDate(1), value: 3 },
                { date: getDate(2), value: 0 },
                { date: getDate(3), value: 4 },
                { date: getDate(4), value: 2 },
                { date: getDate(5), value: 1 },
                { date: getDate(6), value: 1 }
            ], messages: 156, reactions: 43 }, withVolumeDiffs(156, 43)), { activeParticipants: 29, externalPercent: 9, topPosters: [
                { userId: 16, name: 'Casey Kim', posts: 33, department: 'Support' },
                { userId: 17, name: 'Riley Chen', posts: 27, department: 'Product' },
                {
                    userId: 18,
                    name: 'Morgan Blake',
                    posts: 22,
                    department: 'Marketing'
                },
                { userId: 19, name: 'Taylor Brooks', posts: 18, department: 'Support' },
                { userId: 20, name: 'Jordan Lee', posts: 14, department: 'Design' }
            ] }),
        __assign(__assign({ roomId: 22, roomName: 'Workalizer Sync', volumeTrend: [
                { date: getDate(0), value: 0 },
                { date: getDate(1), value: 2 },
                { date: getDate(2), value: 1 },
                { date: getDate(3), value: 1 },
                { date: getDate(4), value: 0 },
                { date: getDate(5), value: 1 },
                { date: getDate(6), value: 1 }
            ], messages: 145, reactions: 37 }, withVolumeDiffs(145, 37)), { activeParticipants: 21, externalPercent: 14, topPosters: [
                {
                    userId: 21,
                    name: 'Alex Morgan',
                    posts: 28,
                    department: 'Engineering'
                },
                { userId: 22, name: 'Priya Shah', posts: 24, department: 'Product' },
                { userId: 23, name: 'Sam Rivera', posts: 19, department: 'Sales' },
                { userId: 24, name: 'Taylor Kim', posts: 16, department: 'Marketing' },
                { userId: 25, name: 'Casey Kim', posts: 12, department: 'Support' }
            ] })
    ];
};
